//deps
import React, { memo, useCallback } from "react";

//styles
import { TooltipCloseIcon, Container } from "./styles/Tooltip.style";

export interface TooltipProps {
    children: React.ReactNode;
    onClickClose: VoidFunction;
    className?: string;
    dataTestId?: string;
    closeIconDataTestId?: string;
    bottomArrowPosition?: "left" | "right";
}

const CLOSE_ICON_COLOR = "#FFFFFF";
const CLOSE_ICON_OPACITY = "1";

function Tooltip({
    children,
    onClickClose,
    className,
    dataTestId,
    closeIconDataTestId,
    bottomArrowPosition = "left",
}: TooltipProps) {
    const handleCloseClick = useCallback(
        (e: React.MouseEvent<Element>) => {
            e.stopPropagation();
            onClickClose();
        },
        [onClickClose],
    );

    const handleContainerClick = useCallback((e: React.MouseEvent<Element>) => {
        e.stopPropagation();
    }, []);

    return (
        <Container
            onClick={handleContainerClick}
            className={className}
            data-testid={dataTestId}
            bottomArrowPosition={bottomArrowPosition}
        >
            {children}
            <TooltipCloseIcon
                onClick={handleCloseClick}
                stroke={CLOSE_ICON_COLOR}
                opacity={CLOSE_ICON_OPACITY}
                dataTestId={closeIconDataTestId}
            />
        </Container>
    );
}

export default memo(Tooltip);
